// dependencies
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// components\

// actions
import { logout } from "Actions/authentication";

// selectors

// styles
import css from "./Logout.styl";

class LoginPage extends React.Component {
	static propTypes = {
		logout: PropTypes.func.isRequired,
	};

	componentDidMount = () => {
		this.props.logout();
	};

	render() {
		return <div className={css.logoutPage} />;
	}
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
	logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
